import classNames from 'classnames';
import { nanoid } from 'nanoid';
import { OverlayTrigger } from 'react-bootstrap';

import Tooltip from '../Tooltip';

import styles from './_index.module.scss';

interface TagProps extends React.HTMLAttributes<HTMLElement> {
  icon: React.ReactElement;
  label?: string;
  placement?: 'bottom' | 'left' | 'right' | 'top';
  tooltip?: string;
}

const Tag = ({ className, icon, label, placement, tooltip, ...props }: TagProps) => {
  const tagClasses = classNames(styles['tag'], className);

  if (!tooltip) {
    const labelId = nanoid();
    return (
      <i aria-labelledby={labelId} className={tagClasses} role="img" {...props}>
        {icon}
        {label && <span id={labelId}>{label}</span>}
      </i>
    );
  }

  return (
    <OverlayTrigger
      delay={{ hide: 0, show: 400 }}
      overlay={<Tooltip>{tooltip}</Tooltip>}
      placement={placement}
    >
      <i aria-label={tooltip} className={tagClasses} role="img" {...props}>
        {icon}
      </i>
    </OverlayTrigger>
  );
};

export default Tag;
